module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs conversions-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/refunds/return_by_month',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ref_return_by_month')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/refunds/cancel_by_month',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ref_cancel_by_month')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/refunds/cancel_operators',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ref_cancel_operators')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09d9c7c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/refunds/RefundsTabs.vue
// module id = 510
// module chunks = 0